import { graphql, Link, useStaticQuery } from "gatsby"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import React, { useState } from "react"
import {
    AppBar,
    Toolbar,
    Typography,
    CssBaseline,
    makeStyles,
    useTheme,
    IconButton,
    Drawer,
    List,
} from "@material-ui/core"
import { Menu as MenuIcon, Close as CloseIcon } from "@material-ui/icons"
import { linkReset } from "../helpers/linkReset"
import { DesktopButton } from "./header/desktopButtons"
import { MobileButton } from "./header/mobileButton"

const useStyles = makeStyles(theme => ({
    toolbar: {
        flexGrow: 1,
    },
    title: {
        ...linkReset,
        flexGrow: 1,
    },
    list: {
        width: 250,
    },
    sideAppBar: {
        height: "100%",
        justifyContent: "center",
        "& h6": {
            verticalAlign: "middle",
        },
    },
    drawerToolbar: theme.mixins.toolbar,
}))

const Header = () => {
    const theme = useTheme()
    const small = useMediaQuery(theme.breakpoints.down("sm"))
    const [drawerOpen, setDrawerOpen] = useState(false)

    const data = useStaticQuery(graphql`
        query {
            allGoogleSheetPagesRow {
                nodes {
                    name
                    link
                    mobileonly
                    external
                }
            }
            pageText {
                title
            }
        }
    `)

    const links = data.allGoogleSheetPagesRow.nodes

    const classes = useStyles()

    return (
        <AppBar position={"sticky"}>
            <CssBaseline/>
            <Toolbar className={classes.toolbar}>
                {
                    small &&
                    <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu"
                                onClick={() => setDrawerOpen(true)}>
                        <MenuIcon/>
                    </IconButton>
                }
                <Typography variant={"h6"} className={classes.title} component={Link} to={"/"}>
                    {data.pageText.title}
                </Typography>
                {!small && links.filter(l => !l.mobileonly).map(l =>
                    <DesktopButton
                        key={l.link}
                        {...l}
                    />)
                }
            </Toolbar>
            <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
                <AppBar position={"static"}>
                    <Toolbar>
                        <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu"
                                    onClick={() => setDrawerOpen(false)}>
                            <CloseIcon/>
                        </IconButton>
                        <Typography variant={"h6"} className={classes.title} component={Link} to={"/"}>
                            Menu
                        </Typography>
                    </Toolbar>
                </AppBar>
                <List className={classes.list}>
                    {links.map(l => <MobileButton key={l.link} {...l} />)}
                </List>
            </Drawer>
        </AppBar>
    )
}

export default Header
